import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: [],
    contractStoreDetails: [],
    listContract: [],
    agentCreditDetails: [],
    agentProducts: [],
    loading: false,
  },
  getters: {
    list: (state) => state.list,
    listContract: (state) => state.listContract,
    details: (state) => state.details,
    contractStoreDetails: (state) => state.contractStoreDetails,
    loading: (state) => state.loading,
    InternalSalesList: (state) =>
      state.list.filter((x) => x.contractType == "InternalSales"),
    agentCreditDetails: (state) => state.agentCreditDetails,
    agentProducts: (state) => state.agentProducts,
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Sales/api/ContractsQuery").then((r) => {
        commit("setList", r.data.data);
      });
    },
    fetchContractList({ commit, dispatch }) {
      return ajax.get("Sales/api/ContractsQuery/all-tiny-info").then((r) => {
        commit("setlistContract", r.data);
      });
    },
    fetchNoSkip({ commit, dispatch }) {
      return ajax.get("Sales/api/ContractsQuery?Take=5000&Skip=0").then((r) => {
        commit("setList", r.data.data);
      });
    },
    fetchChannelContract({ commit, dispatch }) {
      return ajax.get("/Sales/api/ContractsQuery/0/0/0/2").then((r) => {
        commit("setList", r.data);
      });
    },
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ContractsQuery/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            setTimeout(() => {
              commit("setLoading", false);
            }, 0);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    searchContractProducts({ commit, dispatch }, { id, name }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ContractsQuery/" + id + "/" + name + "/0")
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    fetchContract({ commit, dispatch }) {
      return ajax.get("Sales/api/ContractsQuery").then(() => {
        dispatch("fetch");
      });
    },
    createContract({ commit, dispatch }, model) {
      return ajax.post("Sales/api/Contracts", model).then(() => {});
    },
    removeContract({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Sales/api/Contracts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    updateContract({ commit, dispatch }, model) {
      return ajax.put("Sales/api/Contracts", model).then(() => {});
    },
    assignContractProductsInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Sales/api/ContractProductsInfo", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    assignContractConfigurableProductsInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Sales/api/ContractProductsInfo/configurable-product", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },

    updateContractProductsInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/ContractProductsInfo", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    updatePrice({ commit, dispatch }, id) {
      return ajax
        .put(
          "Sales/api/ContractProductPrice",
          { contractId: id },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    showListAllBrands({ commit }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/BrandsQuery/all-tiny-info")
          .then((r) => {
            commit("setList", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    showListAllGenericProducts({ commit }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/GenericProductsQuery/all-tiny-info")
          .then((r) => {
            commit("setList", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    showListAllWarranties({ commit }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/WarrantiesQuery/all-tiny-info")
          .then((r) => {
            commit("setList", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },

    contractsQuerySearch({ commit, dispatch }, { id, name }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ContractsQuery/" + id + "/" + name + "/0")
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    assignWarehouse({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Sales/api/ContractWarehouse", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    updateWarehouse({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/ContractWarehouse", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    assignContractStore({ commit, dispatch }, model) {
      return ajax.put("Sales/api/ContractStore", model).then(() => {});
    },
    fetchSingleContractStore({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ContractStoreQuery/" + id)
          .then((r) => {
            commit("setcontractStoreDetails", r.data);
            setTimeout(() => {
              commit("setLoading", false);
            }, 5000);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchActualSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ActualProductsQuery?keyword=" + name)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    fetchActualSearchForCollection({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("CMS/api/MenuProductsQuery/0/0/" + name)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createSalesPerson({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Sales/api/SalePerson", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    deleteSalesPerson({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Sales/api/SalePerson",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    attachAgentInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/SalePerson/AgentInfo", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    attachAdminInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/SalePerson/assign-admin-info", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    deleteAssignAdminToSalesPerson({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Sales/api/SalePerson/remove-admin-info",
          { data: { salePersonId: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    unassignAgentInfo({ commit, dispatch }, { salePersonId, agentId }) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "Sales/api/SalePerson/Agent-info",
            { data: { salePersonId: salePersonId, agentId: agentId } },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    fetchAgentCredit({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SaleAgentsQuery/" + id + "/credit")
          .then((r) => {
            commit("setAgentCreditDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    SaleAgentsRelatedSalesPersonById({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SaleAgentsQuery/" + id + "/related-sales-person")
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchAgentProducts({ commit }, id) {
      return new Promise((resolve, reject) => {
        return ajax
          .get("Sales/api/SaleAgentsQuery/" + id + "/Quotas")
          .then((r) => {
            commit("setAgentProducts", r.data);
            resolve(r.data);
            return r.data;
          })
          .catch((e) => reject(e));
      });
    },
    createBasketRecipients({ commit, dispatch }, model) {
      return ajax.post("Sales/api/BasketRecipients", model).then(() => {});
    },
    deleteBasketRecipients({ commit, dispatch }, { basketId, ownerUserId }) {
      return ajax
        .delete(
          "Sales/api/BasketRecipients",
          { data: { basketId: basketId, ownerUserId: ownerUserId } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    createSaleProductManager({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Sales/api/SaleProductManager", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    deleteSaleProductManager({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Sales/api/SaleProductManager",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    assignContractToSaleProductManager({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/SaleProductManager/contract-info", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    unassignSaleProductManagerContract(
      { commit, dispatch },
      { saleProductManagerId, contractId }
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "Sales/api/SaleProductManager/contract-info",
            {
              data: {
                saleProductManagerId: saleProductManagerId,
                contractId: contractId,
              },
            },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    assignSegmentToSaleProductManager({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/SaleProductManager/segment-info", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    unassignSaleProductManagerSegment(
      { commit, dispatch },
      { saleProductManagerId, segmentId }
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "Sales/api/SaleProductManager/segment-info",
            {
              data: {
                saleProductManagerId: saleProductManagerId,
                segmentId: segmentId,
              },
            },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    dischargeAllExpiredQuotas({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "Sales/api/DischargeTransactions/manually-base-on-expiration-clock",
            {},
            { headers: { "Content-Type": "application/json" } }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
      state.list.unshift({
        id: "",
        title: "همه قراردادها",
      });
    },
    setlistContract(state, data) {
      state.listContract = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setcontractStoreDetails(state, data) {
      state.contractStoreDetails = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setAgentCreditDetails(state, data) {
      state.agentCreditDetails = data;
    },
    setAgentProducts(state, data) {
      state.agentProducts = data;
    },
  },
};
